import { render, staticRenderFns } from "./StatsTeamChart.vue?vue&type=template&id=dbfa59fa&scoped=true&"
import script from "./StatsTeamChart.vue?vue&type=script&lang=js&"
export * from "./StatsTeamChart.vue?vue&type=script&lang=js&"
import style0 from "./StatsTeamChart.vue?vue&type=style&index=0&id=dbfa59fa&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbfa59fa",
  null
  
)

export default component.exports